<template>
  <div v-if="visible" class="pickup-modal-overlay" @click.self="$emit('close')">
    <div class="pickup-modal-box">
      <div class="pickup-modal-hd">
        <h3>
          <svg width="14" height="14" viewBox="0 0 12 12">
            <rect x="0" y="0" width="5" height="5" rx="1" fill="#4a235a"/>
            <rect x="7" y="0" width="5" height="5" rx="1" fill="#4a235a" opacity="0.45"/>
            <rect x="0" y="7" width="5" height="5" rx="1" fill="#4a235a" opacity="0.45"/>
            <rect x="7" y="7" width="5" height="5" rx="1" fill="#4a235a"/>
          </svg>
          ピックアップコーナー 表示プレビュー
        </h3>
        <button class="pickup-modal-close" @click="$emit('close')">×</button>
      </div>

      <div class="pickup-status-bar">

        <span class="pickup-status-date" v-if="modalData.rakutenPickupCreateDate">登録日：{{ modalData.rakutenPickupCreateDate }}</span>
        <span class="pickup-status-date" v-if="modalData.rakutenPickupUpdateDate">更新日：{{ modalData.rakutenPickupUpdateDate }}</span>
      </div>

      <div class="pickup-modal-bd" :style="isBasicPlan ? 'overflow: hidden' : ''"  >
        <div class="pickup-preview-wrap" :class="{ 'pickup-preview-blurred': isBasicPlan }">
          <div ref="previewContainer" class="pickup-preview-inner"></div>
        </div>
        <div v-if="isBasicPlan" class="pickup-basic-overlay">
          <div class="pickup-basic-box">
            <p class="font-bold">ピックアップコーナーを掲載するには、<span class="plan-premium-text">プレミアム</span>へのご登録が必要となります</p>
            <button class="btn btn-warning" @click="$router.push('/setting/plan-info')">
              ご登録はこちら
              <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="pickup-modal-ft">
        <button class="pickup-btn-cancel" @click="$emit('close')">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RakutenPickupModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: () => ({
        asin: '',
        rakutenPickupRegistered: false,
        rakutenPickupDescription: '',
        rakutenPickupAsins: {},
        rakutenPickupImages: [],
        rakutenPickupCreateDate: '',
        rakutenPickupUpdateDate: ''
      })
    }
  },
  computed: {
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.$nextTick(() => {
          this.renderNewPreview()
        })
      }
    }
  },
  methods: {
    // Render pickup corner preview as a 2-column grid using decoded ASIN images from backend
    renderNewPreview () {
      const container = this.$refs.previewContainer
      if (!container) return

      const items = this.modalData.rakutenPickupImages || []
      if (!items.length) {
        container.innerHTML = '<p class="pickup-no-image">画像なし</p>'
        return
      }

      // Split items into rows of 2 for 2-column layout
      const rows = []
      for (let i = 0; i < items.length; i += 2) {
        rows.push(items.slice(i, i + 2))
      }

      // Build each row: left cell always filled, right cell empty if odd total
      const rowsHtml = rows.map(row => {
        const cells = row.map(item => {
          const imgHtml = item.imageUrl
            ? `<div class="pickup-grid-img-wrap"><img class="pickup-grid-img" src="${item.imageUrl}" alt="${item.asin || ''}"></div>`
            : '<div class="pickup-grid-no-img">No Image</div>'
          return `
          <div class="pickup-grid-cell">
            <div class="pickup-grid-asin">ASIN：${item.asin || ''}</div>
            ${imgHtml}
          </div>
        `
        }).join('')

        // Pad with empty cell if row has only 1 item
        const padding = row.length < 2 ? '<div class="pickup-grid-cell"></div>' : ''

        return `<div class="pickup-grid-row">${cells}${padding}</div>`
      }).join('')

      container.innerHTML = rowsHtml
    }
  }
}
</script>

<style scoped>
.pickup-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.42);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pickup-modal-box {
  background: #fff;
  border-radius: 8px;
  width: 760px;
  max-width: 70vw;
  max-height: 70vh;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.pickup-modal-hd {
  background: #f4ecf7;
  border-bottom: 1px solid #c39bd3;
  padding: 11px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.pickup-modal-hd h3 {
  font-size: 15px;
  color: #4a235a;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-weight: 700;
}
.pickup-modal-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}
.pickup-modal-close:hover { color: #c00; }
.pickup-status-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: #faf7fd;
  border-bottom: 1px solid #e8d5f0;
  flex-shrink: 0;
  flex-wrap: wrap;
}
.pickup-status-chip {
  font-size: 11px;
  padding: 2px 10px;
  border-radius: 12px;
  font-weight: bold;
}
.pickup-chip-active {
  background: #e8d5f0;
  color: #4a235a;
}
.pickup-chip-inactive {
  background: #f0f0f0;
  color: #aaa;
}
.pickup-status-date {
  font-size: 13px;
  color: #aaa;
  margin-left: auto;
}
.pickup-status-date + .pickup-status-date {
  margin-left: 0;
}
.pickup-modal-bd {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  position: relative;
}
.pickup-preview-wrap {
  border: 1px dashed #c39bd3;
  padding: 10px;
  background: #faf8fb;
  border-radius: 4px;
}
.pickup-preview-blurred {
  pointer-events: none;
  user-select: none;
}
.pickup-basic-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background: rgba(240, 240, 240, 0.5);
  backdrop-filter: blur(5px);
}
.pickup-basic-box {
  background: white;
  padding: 30px 50px;
  border-radius: 12px;
  text-align: center;
  width: max-content;
  max-width: 80%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-size: 30px;
  white-space: normal;
}
.pickup-basic-box .btn-warning {
  font-size: 20px;
  color: #666;
  font-weight: bold;
  padding: 6px 50px;
}
.pickup-modal-ft {
  border-top: 1px solid #c39bd3;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  background: #f9f4fc;
  flex-shrink: 0;
}
.pickup-btn-cancel {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  border: 1px solid #ccc;
  padding: 5px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}
.pickup-btn-cancel:hover { background: #eee; }
</style>

<style>
/* 2-column grid: equal width columns, small fixed gap */
.pickup-grid-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
}
.pickup-grid-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}
.pickup-grid-asin {
  font-size: 11px;
  font-weight: bold;
  color: #4a235a;
  margin-bottom: 4px;
  word-break: break-all;
  text-align: center;
  width: 100%;
}
/* Fixed height container so all images align to the same row height */
.pickup-grid-img-wrap {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #faf8fb;
  border: 1px solid #e0d0f0;
  border-radius: 4px;
  overflow: hidden;
}
/* Cover fill within container — crops if needed but keeps aspect ratio */
.pickup-grid-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.pickup-grid-no-img {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f0fa;
  border: 1px dashed #c39bd3;
  border-radius: 4px;
  font-size: 11px;
  color: #aaa;
}
.pickup-no-image {
  text-align: center;
  color: #aaa;
  font-size: 12px;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/RakutenPickupModal.vue